/*eslint eqeqeq: "off"*/
import * as React from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';

import Tabel, { IFilterItems /*, IFilterParams*/ } from '../../MainControl/Table/Tabel';

export interface IAlarm {
    id: string;
    Date: string;
    Desc: string;
    Units: string;
    ItemName: string;
    Active: boolean;
    Ack: boolean;
    Type: string;
    Priority: string;
}

export interface IProps {
    //idUnit: string[];
    config?: string;
}

export interface IState {
    alarms: IAlarm[];
    filterItems: IFilterItems;
    seconds: number;
    //MaxPage: number,
    OptionsPage: OptionsPage;
    colList: string[];
    selectedColList: string[];
    OpenWinColList: boolean;
    //filterParam: IFilterParams,
    loding: boolean;
    setTime: any;
    idUnit: string[];
}

declare global {
    interface Window {
        dataserver: any;
    }
}

interface OptionsPage {
    MaxPage: number;
    SelectPage: number;
    SizePage: number;
}

interface OptionsFilter {
    options: OptionFilter[];
}

interface OptionFilter {
    comparison: string;
    field: string;
    value: string;
}

interface filters {
    filters: OptionFilter[];
    operation: string;
}

interface filterGroups {
    filterGroups: filters[];
    objectIds: string[];
}

class AlarmsIndex extends React.Component<IProps, IState> {
    /*

    React.useEffect(() => {     
        const interval = setInterval(() => {
            AlarmsUpdate(OptionsPage);   
        }, seconds);
        return () => clearTimeout(interval);
    }, [alarms, OptionsPage]);

*/
    private cookies = new Cookies();

    constructor(props: IProps) {
        super(props);

        let dateFormat = require('dateformat');
        let formatDate = "yyyy-mm-dd'T'HH:MM:ss";
        let LastDate = new Date();
        let firstDate = new Date();
        firstDate = new Date(firstDate.setDate(firstDate.getDate() - 3));

        this.state = {
            alarms: [],
            filterItems: {
                Date: {
                    desc: 'Дата',
                    filterList: new Map(),
                    typeFilter: 'Date',
                    sortFilter: {
                        sortItem: [dateFormat(firstDate, formatDate), dateFormat(LastDate, formatDate)],
                        sortCol: 'default',
                        sortUp: false
                    }
                },
                Desc: {
                    desc: 'Описание',
                    filterList: new Map(),
                    typeFilter: 'Input',
                    sortFilter: { sortItem: [], sortCol: 'default', sortUp: false }
                },
                ItemName: {
                    desc: 'Установка',
                    filterList: new Map(),
                    typeFilter: 'List',
                    sortFilter: { sortItem: [], sortCol: 'default', sortUp: false }
                },
                Units: {
                    desc: 'Объект',
                    filterList: new Map(),
                    typeFilter: 'List',
                    sortFilter: { sortItem: [], sortCol: 'default', sortUp: false }
                },
                Active: {
                    desc: 'Активна',
                    filterList: new Map().set('True', 'True').set('False', 'False'),
                    typeFilter: 'List',
                    sortFilter: { sortItem: [], sortCol: 'default', sortUp: false },
                    width: 50
                },
                Ack: {
                    desc: 'Квитировано',
                    filterList: new Map().set('True', 'True').set('False', 'False'),
                    typeFilter: 'List',
                    sortFilter: { sortItem: [], sortCol: 'default', sortUp: false },
                    width: 50
                },
                Type: {
                    desc: 'Тип',
                    filterList: new Map(),
                    typeFilter: 'List',
                    sortFilter: { sortItem: [], sortCol: 'default', sortUp: false }
                },
                Priority: {
                    desc: 'Приоритет',
                    filterList: new Map(),
                    typeFilter: 'List',
                    sortFilter: { sortItem: [], sortCol: 'default', sortUp: false }
                }
            },
            seconds: 10000,
            OptionsPage: {
                MaxPage: 0,
                SelectPage: 0,
                SizePage: 25
            },
            colList: ['Date', 'Desc', 'Units', 'ItemName', 'Active', 'Ack', 'Type', 'Priority'],
            selectedColList: ['Date', 'Desc', 'Units', 'ItemName', 'Active', 'Ack', 'Type', 'Priority'],
            OpenWinColList: false,
            loding: false,
            setTime: {},
            idUnit: [window.EventSelectedMenuItem]
        };
    }

    componentDidMount() {
        window.addEventListener('EventSelectedMenuItem', (ev: any) => {
            this.listenerEvent(ev);
        });
        this.AlarmsUpdate(this.state.OptionsPage, this.state.idUnit);
        //this.setState({ loding: true });

        let OptionTable: string = this.cookies.get('OptionTableAlarms');
        if (OptionTable != undefined) {
            let TempCollist: string[] = [...this.state.colList];
            let TempOpTable: string[] = OptionTable.split(',');
            for (let ind = 0; ind < TempOpTable.length; ind++) {
                let indexItem = TempCollist.indexOf(TempOpTable[ind]);
                console.debug(TempOpTable[ind] + ' ' + indexItem);
                if (indexItem > -1) TempCollist.splice(indexItem, 1);
            }
            this.setState({ selectedColList: TempCollist });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.state.setTime);
        window.removeEventListener('EventSelectedMenuItem', (ev: any) => {
            this.listenerEvent(ev);
        });
    }

    private OnClickColListSelected(item: string) {
        let TempCollist: string[] = [...this.state.selectedColList];
        let indexItem = TempCollist.indexOf(item);
        if (indexItem > -1) TempCollist.splice(indexItem, 1);
        else TempCollist.push(item);

        let TempOpTable: string[] = [];
        let NewSelectedColList: string[] = [];
        for (let ind = 0; ind < this.state.colList.length; ind++) {
            let indexItem = TempCollist.indexOf(this.state.colList[ind]);
            if (indexItem == -1) TempOpTable.push(this.state.colList[ind]);
            else NewSelectedColList.push(this.state.colList[ind]);
        }
        this.cookies.set('OptionTableAlarms', TempOpTable.join(','), { path: '/' });

        this.setState({ selectedColList: NewSelectedColList });
    }

    private listenerEvent(event: any) {
        console.debug('IdItem=' + event.detail.id);
        let tempidUnit: string[] = [];
        tempidUnit.push(event.detail.id);

        const hashOld = JSON.stringify(this.state.idUnit); //crc32.str(JSON.stringify(this.state.idUnit));
        const hashNew = JSON.stringify(tempidUnit); //crc32.str(JSON.stringify(tempidUnit))

        if (hashOld != hashNew) {
            this.setState({ idUnit: tempidUnit });
            this.AlarmsUpdate(this.state.OptionsPage, tempidUnit);
        }
    }

    private async FilterList(alarms: IAlarm[]) {
        let temp: IFilterItems = Object.assign({}, this.state.filterItems);
        //let ItemNameMap: Map
        let TypeMap = new Map();
        let PriorityMap = new Map();
        for (let index = 0; index < alarms.length; index++) {
            let ItemAlarm: IAlarm = alarms[index];
            if (!TypeMap.has(ItemAlarm.Type)) TypeMap.set(ItemAlarm.Type, ItemAlarm.Type);
            if (!PriorityMap.has(ItemAlarm.Priority)) PriorityMap.set(ItemAlarm.Priority, ItemAlarm.Priority);
        }
        temp['Type'].filterList = TypeMap;
        temp['Priority'].filterList = PriorityMap;
        this.setState({ filterItems: temp });
    }

    private AlarmsUpdate(OptPage: OptionsPage, idUnit: string[]) {
        this.setState({ loding: true });
        clearTimeout(this.state.setTime);
        //let formData = new FormData();
        //formData.append("objectIds", '["LUKOIL"]'); "LUKOIL", "61d4ff36-0b09-44e0-bb3f-368de5fd5014", "905cd8fa-1228-4a27-be71-f17742ab226f", "PNOS", "Pn40", "PlantUnit_d2032207c01069e4b4ebfff64396pgpn5"
        //let formData: any = { "filterGroups": [{ "filters": [{ "comparison": "MOREOREQUAL", "field": "from", "value": "2021-02-03T10:16:14.243Z" }, { "comparison": "LESSOREQUAL", "field": "from", "value": "2021-02-20T10:16:14.243Z" }], "operation": "AND" }], "objectIds": ["LUKOIL"] }
        let filters: OptionFilter[] = [];
        for (let count = 0; count < this.state.colList.length; count++) {
            let key = this.state.colList[count];
            if (this.state.filterItems[key].typeFilter == 'Date') {
                if (this.state.filterItems[key].sortFilter.sortItem.length > 0) {
                    let DateFirst: OptionFilter = {
                        comparison: 'MOREOREQUAL',
                        field: 'from',
                        value: this.state.filterItems[key].sortFilter.sortItem[0]
                    };
                    filters.push(DateFirst);
                    let DateLast: OptionFilter = {
                        comparison: 'LESSOREQUAL',
                        field: 'from',
                        value: this.state.filterItems[key].sortFilter.sortItem[1]
                    };
                    filters.push(DateLast);
                }
            } else if (this.state.filterItems[key].typeFilter == 'List') {
                if (this.state.filterItems[key].sortFilter.sortItem.length > 0) {
                }
            }
        }

        let formData: filterGroups = { filterGroups: [{ filters: filters, operation: 'AND' }], objectIds: idUnit };

        return fetch(
            `/events-objects-hierarchy/restapi/events/byQuery?page=` + OptPage.SelectPage + `&size=` + OptPage.SizePage,
            {
                method: 'POST',
                cache: 'no-cache',
                headers: {
                    Accept: 'application/json;charset=UTF-8',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            }
        )
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);
                return response.json();
            })
            .then((data) => {
                this.SetAlarmsData(data);
            })
            .catch((error) => {
                this.SetAlarmsData([]);
                console.warn('error', error);
            });
    }

    private SetAlarmsData(alarmslist: any) {
        //console.log("DATA");
        //console.debug(alarmslist);
        let listalarm: IAlarm[] = [];
        if (alarmslist.content != undefined) {
            alarmslist.content.forEach((item: any) => {
                let TempItem: IAlarm = {
                    id: item.id,
                    Date: item.from,
                    Desc: item.description,
                    Units: item.attributes.relatedToPlantUnitName,
                    ItemName: item.element.name,
                    Active: item.attributes.active,
                    Ack: item.attributes.acked,
                    Type: item.eventTypeId,
                    Priority: item.attributes.severityLevel
                };
                listalarm.push(TempItem);
            });

            //console.debug(hashOld);
            //console.debug(hashNew);
        }
        const hashOld = JSON.stringify(this.state.alarms);
        const hashNew = JSON.stringify(listalarm);

        let setTime = setTimeout(() => {
            this.AlarmsUpdate(this.state.OptionsPage, this.state.idUnit);
            this.setState({ loding: false });
        }, this.state.seconds);

        let TempOptionsPage: OptionsPage = Object.assign({}, this.state.OptionsPage);
        TempOptionsPage.MaxPage = alarmslist.totalPages != undefined ? alarmslist.totalPages : 0;

        if (hashOld != hashNew) {
            //console.debug("Update Alarms");
            this.setState({ OptionsPage: TempOptionsPage, alarms: listalarm, setTime: setTime, loding: false });
            this.FilterList(listalarm);
        } else {
            this.setState({ OptionsPage: TempOptionsPage, setTime: setTime, loding: false });
        }
    }

    private selectFindItem(item: string, value: string, key: string) {
        //console.debug("selectFindItem:item=" + item + " value=" + value + " key=" + key);
        //console.debug(this.state.filterItems);
        let temp: IFilterItems = Object.assign({}, this.state.filterItems);

        if (value == 'default') {
            temp[item].sortFilter.sortCol = 'default';
            temp[item].sortFilter.sortUp = false;
            temp[item].sortFilter.sortItem = [];

            this.setState({ filterItems: temp });
            this.AlarmsUpdate(this.state.OptionsPage, this.state.idUnit);
        } else if (value == 'alfabet') {
            temp[item].sortFilter.sortUp = !temp[item].sortFilter.sortUp;
            this.setState({ filterItems: temp });
            this.AlarmsUpdate(this.state.OptionsPage, this.state.idUnit);
        } else {
            if (
                this.state.filterItems[item].typeFilter != undefined &&
                this.state.filterItems[item].typeFilter == 'Date'
            ) {
                if (key == 'First') temp[item].sortFilter.sortItem[0] = value;
                else temp[item].sortFilter.sortItem[1] = value;
                this.setState({ filterItems: temp });
            } else if (
                this.state.filterItems[item].typeFilter != undefined &&
                this.state.filterItems[item].typeFilter == 'List'
            ) {
            } else if (
                this.state.filterItems[item].typeFilter != undefined &&
                this.state.filterItems[item].typeFilter == 'Input'
            ) {
                //console.debug("Input");
                temp[item].sortFilter.sortItem[0] = value;
                this.setState({ filterItems: temp });
            }
        }
    }

    private OnClikcFilter(nameButton: string) {
        this.AlarmsUpdate(this.state.OptionsPage, this.state.idUnit);
    }

    private NextPage() {
        if (this.state.OptionsPage.SelectPage < this.state.OptionsPage.MaxPage - 1) {
            let OptPage: OptionsPage = {
                MaxPage: this.state.OptionsPage.MaxPage,
                SelectPage: this.state.OptionsPage.SelectPage + 1,
                SizePage: this.state.OptionsPage.SizePage
            };
            this.AlarmsUpdate(OptPage, this.state.idUnit);
            this.setState({ OptionsPage: OptPage });
        }
    }
    private PrevPage() {
        if (this.state.OptionsPage.SelectPage > 0) {
            let OptPage: OptionsPage = {
                MaxPage: this.state.OptionsPage.MaxPage,
                SelectPage: this.state.OptionsPage.SelectPage - 1,
                SizePage: this.state.OptionsPage.SizePage
            };
            this.AlarmsUpdate(OptPage, this.state.idUnit);
            this.setState({ OptionsPage: OptPage });
        }
    }

    render() {
        let ViewColFilter = () => {
            let forList: any = [];
            this.state.colList.forEach((value: string, key: any, arr: any) => {
                //console.debug(arr);
                let selected = false;
                let indexItem = this.state.selectedColList.indexOf(value);
                if (indexItem > -1) {
                    selected = true;
                }
                /*
                let ViewVector = () => {
                    if (key == 0)
                        return (
                            <div>
                                <svg width="10" height="10" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.91572 4.71232L4.71266 8.91213C4.65621 8.9684 4.57974 9 4.5 9C4.42027 9 4.34379 8.9684 4.28734 8.91213L0.0842826 4.71232C0.0295904 4.65574 -0.000672736 4.57995 1.13501e-05 4.50129C0.000695436 4.42263 0.032272 4.34738 0.08794 4.29176C0.143608 4.23613 0.218913 4.20458 0.297637 4.2039C0.376361 4.20321 0.452203 4.23345 0.50883 4.2881L4.19975 7.97615V0.300014C4.19975 0.220445 4.23139 0.144136 4.28769 0.0878721C4.344 0.0316085 4.42037 0 4.5 0C4.57963 0 4.656 0.0316085 4.71231 0.0878721C4.76861 0.144136 4.80025 0.220445 4.80025 0.300014V7.97615L8.49117 4.2881C8.5478 4.23345 8.62364 4.20321 8.70236 4.2039C8.78109 4.20458 8.85639 4.23613 8.91206 4.29176C8.96773 4.34738 8.9993 4.42263 8.99999 4.50129C9.00067 4.57995 8.97041 4.65574 8.91572 4.71232Z" fill="#7B7B7B" />
                                </svg>
                            </div>
                            );
                    else if (key == this.state.colList.length - 1)
                        return (
                            <div>
                                <svg width="10" height="10" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.0842833 4.28768L4.28734 0.0878692C4.34379 0.0316005 4.42027 -4.00373e-07 4.5 -3.93402e-07C4.57974 -3.86432e-07 4.65622 0.0316006 4.71266 0.0878693L8.91572 4.28768C8.97041 4.34426 9.00067 4.42005 8.99999 4.49871C8.9993 4.57737 8.96773 4.65262 8.91206 4.70824C8.85639 4.76387 8.78109 4.79542 8.70236 4.7961C8.62364 4.79679 8.5478 4.76655 8.49117 4.7119L4.80025 1.02385L4.80025 8.69999C4.80025 8.77955 4.76861 8.85586 4.71231 8.91213C4.656 8.96839 4.57963 9 4.5 9C4.42037 9 4.344 8.96839 4.28769 8.91213C4.23139 8.85586 4.19975 8.77955 4.19975 8.69999L4.19975 1.02385L0.508831 4.7119C0.452204 4.76655 0.376361 4.79679 0.297637 4.7961C0.218914 4.79542 0.143608 4.76387 0.0879406 4.70824C0.0322727 4.65262 0.000695615 4.57737 1.18376e-05 4.49871C-0.000672894 4.42004 0.029591 4.34426 0.0842833 4.28768Z" fill="#7B7B7B" />
                                </svg>
                            </div>
                            );
                    else return (
                        <div>
                            <svg width="10" height="10" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.91572 4.71232L4.71266 8.91213C4.65621 8.9684 4.57974 9 4.5 9C4.42027 9 4.34379 8.9684 4.28734 8.91213L0.0842826 4.71232C0.0295904 4.65574 -0.000672736 4.57995 1.13501e-05 4.50129C0.000695436 4.42263 0.032272 4.34738 0.08794 4.29176C0.143608 4.23613 0.218913 4.20458 0.297637 4.2039C0.376361 4.20321 0.452203 4.23345 0.50883 4.2881L4.19975 7.97615V0.300014C4.19975 0.220445 4.23139 0.144136 4.28769 0.0878721C4.344 0.0316085 4.42037 0 4.5 0C4.57963 0 4.656 0.0316085 4.71231 0.0878721C4.76861 0.144136 4.80025 0.220445 4.80025 0.300014V7.97615L8.49117 4.2881C8.5478 4.23345 8.62364 4.20321 8.70236 4.2039C8.78109 4.20458 8.85639 4.23613 8.91206 4.29176C8.96773 4.34738 8.9993 4.42263 8.99999 4.50129C9.00067 4.57995 8.97041 4.65574 8.91572 4.71232Z" fill="#7B7B7B" />
                            </svg>
                            <svg width="10" height="10" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.0842833 4.28768L4.28734 0.0878692C4.34379 0.0316005 4.42027 -4.00373e-07 4.5 -3.93402e-07C4.57974 -3.86432e-07 4.65622 0.0316006 4.71266 0.0878693L8.91572 4.28768C8.97041 4.34426 9.00067 4.42005 8.99999 4.49871C8.9993 4.57737 8.96773 4.65262 8.91206 4.70824C8.85639 4.76387 8.78109 4.79542 8.70236 4.7961C8.62364 4.79679 8.5478 4.76655 8.49117 4.7119L4.80025 1.02385L4.80025 8.69999C4.80025 8.77955 4.76861 8.85586 4.71231 8.91213C4.656 8.96839 4.57963 9 4.5 9C4.42037 9 4.344 8.96839 4.28769 8.91213C4.23139 8.85586 4.19975 8.77955 4.19975 8.69999L4.19975 1.02385L0.508831 4.7119C0.452204 4.76655 0.376361 4.79679 0.297637 4.7961C0.218914 4.79542 0.143608 4.76387 0.0879406 4.70824C0.0322727 4.65262 0.000695615 4.57737 1.18376e-05 4.49871C-0.000672894 4.42004 0.029591 4.34426 0.0842833 4.28768Z" fill="#7B7B7B" />
                            </svg>

                        </div>
                            );
                }
                */
                forList.push(
                    <div
                        style={{
                            height: '2.4em',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '0 0 0 2.4em',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            background: selected ? 'rgba(202, 234, 240, 0.5)' : '#fff'
                        }}
                        key={key}
                        onClick={() => {
                            this.OnClickColListSelected(value);
                        }}>
                        <text>{value}</text>
                        {selected && (
                            <div style={{ margin: '0.5em 1em' }}>
                                <svg
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.39959 0.429971C6.89263 2.89964 5.31526 5.32212 3.68155 7.69741C2.9492 6.98954 2.20276 6.28168 1.47041 5.57381C0.653553 4.78729 -0.543561 6.10864 0.273293 6.91089C1.24507 7.85471 2.21684 8.78281 3.2027 9.72663C3.51254 10.0255 4.10406 10.1514 4.39982 9.72663C6.30112 7.021 8.132 4.23672 9.85021 1.38952C10.4699 0.36705 9.00519 -0.576773 8.39959 0.429971Z"
                                        fill="#66C3D0"
                                    />
                                </svg>
                            </div>
                        )}
                    </div>
                );
            });

            return (
                <div
                    style={{
                        position: 'absolute',
                        background: '#fff',
                        boxShadow: '0px 0px 4px 4px rgba(0, 0, 0, 0.1)',
                        width: '19.5em',
                        marginTop: '1em',
                        overflow: 'hidden',
                        opacity: 1,
                        transition: 'opacity .3s, max-height .2s',
                        maxHeight: '30.8em',
                        bottom: '55px',
                        right: '15px'
                    }}>
                    <div
                        style={{
                            overflow: 'hidden',
                            transition: 'opacity .3s, max-height .2s',
                            maxHeight: '100%'
                        }}>
                        {forList}
                    </div>
                </div>
            );
        };

        let ButtonLeft = () => {
            return (
                <button
                    style={{
                        order: 1,
                        padding: 0,
                        minWidth: 0,
                        width: '40px',
                        height: '40px',
                        flexShrink: 0,
                        lineHeight: '40px',
                        borderRadius: '50%',
                        border: 'none',
                        background: '#fff',
                        cursor: this.state.OptionsPage.SelectPage == 0 ? 'default' : 'pointer'
                    }}
                    type="button"
                    onClick={() => {
                        this.PrevPage();
                    }}>
                    <span>
                        <svg
                            focusable="false"
                            viewBox="0 0 24 24"
                            style={{ fill: this.state.OptionsPage.SelectPage == 0 ? '#bbb' : '#000' }}>
                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                        </svg>
                    </span>
                </button>
            );
        };
        let ButtonRight = () => {
            return (
                <button
                    style={{
                        order: 3,
                        padding: 0,
                        minWidth: 0,
                        width: '40px',
                        height: '40px',
                        flexShrink: 0,
                        lineHeight: '40px',
                        borderRadius: '50%',
                        border: 'none',
                        background: '#fff',
                        cursor:
                            this.state.OptionsPage.SelectPage >= this.state.OptionsPage.MaxPage - 1
                                ? 'default'
                                : 'pointer'
                    }}
                    type="button"
                    onClick={() => {
                        this.NextPage();
                    }}>
                    <span>
                        <svg
                            focusable="false"
                            viewBox="0 0 24 24"
                            style={{
                                fill:
                                    this.state.OptionsPage.SelectPage >= this.state.OptionsPage.MaxPage - 1
                                        ? '#bbb'
                                        : '#000'
                            }}>
                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                        </svg>
                    </span>
                </button>
            );
        };

        return (
            <React.Fragment>
                <div style={{ height: 'calc(100% - 54px)', overflowX: 'auto', position: 'relative' }}>
                    <Tabel
                        reports={this.state.alarms}
                        colList={this.state.selectedColList}
                        filterItems={this.state.filterItems}
                        minWindth={1200}
                        selectFindItem={(item: string, value: string, key: string) =>
                            this.selectFindItem(item, value, key)
                        }
                        OnClikcFilter={(nameButton: string) => this.OnClikcFilter(nameButton)}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        minHeight: '54px',
                        padding: '0 8px',
                        flexWrap: 'wrap-reverse',
                        width: '100%'
                    }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ order: 2, fontSize: '1.2rem', margin: '0' }}>
                            Страница {this.state.OptionsPage.SelectPage + 1}
                        </div>
                        {ButtonLeft()}
                        {ButtonRight()}
                        <div
                            style={{ height: '2.4em', width: '2.4em' }}
                            onClick={() => {
                                this.setState({ OpenWinColList: !this.state.OpenWinColList });
                            }}>
                            <svg viewBox="0 0 22 22" className="ng-star-inserted">
                                <path
                                    _ngcontent-emo-c1=""
                                    d="M5 2C5.5 2 6 2.4 6 3L6 19C6 19.5 5.5 20 5 20H2C1.4 20 1 19.5 1 19V3C1 2.4 1.4 2 2 2H5Z"></path>
                                <path
                                    _ngcontent-emo-c1=""
                                    d="M19 2C19.5 2 20 2.4 20 3V19C20 19.5 19.5 20 19 20H16C15.4 20 15 19.5 15 19L15 3C15 2.4 15.4 2 16 2H19Z"></path>
                                <path
                                    _ngcontent-emo-c1=""
                                    d="M8 19C8 19.5 8.4 20 9 20H12C12.5 20 13 19.5 13 19L13 3C13 2.4 12.5 2 12 2L9 2C8.4 2 8 2.4 8 3L8 19Z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                {this.state.OpenWinColList ? ViewColFilter() : null}
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        display: this.state.loding ? 'flex' : 'none',
                        position: 'absolute',
                        top: '0',
                        background: '#fff',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                    <img src="../static/images/loading_hend.gif" />
                </div>
            </React.Fragment>
        );
    }
}

export default AlarmsIndex;
